import React, { useEffect, useState } from 'react'
import Moment from 'moment'
import { 
  Row,
  Col,
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup, Label, Input, FormText
} from 'reactstrap'
import _ from 'lodash'
import DatePicker from 'react-datepicker'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import { SkillsFieldData, SkillsDefaultValue } from '../../assets'

const FormContent = ({
  open,
  onLoadSkill,
  selectedStudentCV,
  
  onClose,
  onClickSubmit
}) => {

  const [ skillFormData, onChangeSkillData ] = useState( SkillsDefaultValue )

  useEffect(() => {
    if ( !open ){
      onChangeSkillData( SkillsDefaultValue )
    }
  }, [open])

  const onChangeSkillField = ( key, val ) => {
    let tmp = _.cloneDeep( skillFormData )
    tmp[ key ] = val
    return onChangeSkillData( tmp )
  }

  return (
    <Modal
      isOpen={ open }
      size={ 'xl' }>
      <ModalHeader toggle={() => onClose()}>{ `Create Skill` }</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <Row>
          {
            SkillsFieldData.map( item => (
              <Col key={ item.value } lg={ item.col || 12 }>
                <FormGroup>
                  { 
                    item.label && (
                      <Label>
                        { `${ item.label } ` }
                        { item.required && <span className="text-danger">*</span> }
                      </Label>
                  )}
                  {
                    item.type === 'select' && (
                      <Input
                        type={ item.type }
                        value={ skillFormData[ item.value ] }
                        onChange={ e =>  onChangeSkillField( item.value, e.target.value )}
                        >
                        <option value=""></option>
                        { 
                          item.options.map( option => (
                            <option key={ option.name } value={ option.name }>{ option.name }</option>
                          ))
                        }
                      </Input>
                    )
                  }
                  {
                    ( item.type !== 'select' && item.type !== 'date' ) && (
                      <Input
                        type={ item.type }
                        value={ skillFormData[ item.value ] }
                        onChange={ e => onChangeSkillField( item.value, e.target.value )}/>
                    )
                  }
                  {
                    item.type === 'date' && (
                      <DatePicker
                        className={ 'w-100' }
                        dateFormat="dd-MM-yyyy"
                        selected={ skillFormData[ item.value ] }
                        onChange={ val => onChangeSkillField( item.value, val )}
                      />
                    )
                  }
                  { item.subLabel && <FormText>{ item.subLabel }</FormText> }
                </FormGroup>
              </Col>
            ))
          }
          </Row>
        </Form>
        { onLoadSkill && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button 
          color={ 
            (SkillsFieldData.some( item => item.required && !skillFormData[ item.value ])) 
              ? 'secondary' 
              : 'primary' 
          }
          className="mr-2"
          disabled={ SkillsFieldData.some( item => item.required && !skillFormData[ item.value ])}
          onClick={() => {
            onClickSubmit({
              ... skillFormData,
              student_cv_id: selectedStudentCV.student_cv.id,
            })
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FormContent